import {AdUnitBean} from 'common/api/api.ts'
import {
    DictionarySelector,
    DictionarySelectorProps,
    enumValueToLabelValue
} from 'common/components/dictionary/DictionarySelector.tsx'
import {FC} from 'react'

export const AdUnitFormatTypeSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="adUnitFormatType"
                        loader={() => enumValueToLabelValue([
                            AdUnitBean.FormatTypeEnum.Banner,
                            AdUnitBean.FormatTypeEnum.Native,
                            AdUnitBean.FormatTypeEnum.Video,
                        ])}
                        mode={ props.multiple ? (props.mode ?? 'multiple') : undefined }/>
